import { Component } from "react";
import { v4 } from 'uuid'

class Input extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ref: ''
        }
    }

    componentDidMount() {
        this.setState({ ref: v4() })
    }

    render() {
        const { value, className, style, onChange, name, id, placeholder, label, type, errors, max, ...rest } = this.props
        const { ref } = this.state
        return (
            <div className="w-100">
                {label && (
                    <label htmlFor={id || ref} className="form-label">{label}</label>
                )}
                <input
                    type={type || 'text'}
                    className={errors && Object.keys(errors).find((key) => key === name) ? "form-control border border-danger text-danger" : "form-control"}
                    id={id || ref}
                    name={name || ''}
                    placeholder={placeholder || ''}
                    value={value || ''}
                    onChange={(e) => onChange(e)}
                    disabled={this.props.disabled}
                    {...rest}
                />
                {errors && errors[name] && errors[name].length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {errors[name].map((error) => (
                            <div className="invalid" key={v4()}>
                                {error}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    }
}

export default Input